export default (...args) => {
    // Note that the last argument is an hbs option object, always here,
    // so it must be ignored.

    for (let i = 0, size = args.length - 1; i < size; ++i) {
        if (args[i]) {
            return true;
        }
    }

    return false;
};
